// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
/**
 * Transient class that maintains the current triggers and armed status for a {@link TriggerChannel}.
 */
class TriggerData {
  constructor() {
    this._currentTriggers = [];
    this._currentIndex = -1;
    this.armed = false;
  }

  /*
   * Arms the data to be triggered on next animation loop
   * @param {number} index The index of the data in the {@link TriggerChannel}, so we only trigger once per triggerdata
   * @param {Array<string>} triggers String keys that will trigger callbacks in the {@link AnimationComponent}
   */
  arm(index, triggers) {
    if (triggers === null || triggers.length === 0) {
      this._currentTriggers.length = 0;
      this.armed = false;
    } else if (index !== this._currentIndex) {
      this._currentTriggers.length = 0;
      for (let i = 0, max = triggers.length; i < max; i++) {
        if (triggers[i] && triggers[i] !== '') {
          this._currentTriggers.push(triggers[i]);
        }
      }
      this.armed = true;
    }
    this._currentIndex = index;
  }
}

export default TriggerData;
